import { useGetCheckoutLinksByCheckoutLinkId } from "@birdwatch/client";
import { useMemo } from "react";

import {
  type PresaleOfferTarget,
  toPresaleOfferTarget,
} from "../_libs/presale-offer";

/**
 * The tier the campaign link sells, read from its detail.
 *
 * `/checkout-links/list` is filtered to the campaign's key prefix, so a link outside it
 * never appears there — this detail read is what lets such a link still resolve to the
 * offer it sells instead of silently falling back to the cheapest tier.
 */
export function usePresaleOfferTarget(checkoutLinkId: string | undefined): {
  target: PresaleOfferTarget | undefined;
  isLoading: boolean;
} {
  const query = useGetCheckoutLinksByCheckoutLinkId({
    checkoutLinkId: checkoutLinkId ?? "",
  }).get({ enabled: Boolean(checkoutLinkId) });

  const target = useMemo(
    () => toPresaleOfferTarget(query.data?.lineItems),
    [query.data],
  );

  // Gated on the id as well as the query: a disabled query must never report "loading",
  // or the funnel steps below would hang on a visit that carries no link at all.
  return { target, isLoading: Boolean(checkoutLinkId) && query.isLoading };
}
